/**
 * 配置管理部分接口
 */
import request from "@/utils/request";

// 设备快速查询部分接口--充电枪列表
export async function stubInfoList(data) {
  return request(`/mtsV2/omc/stub/stubInfoList`, {
    method: "POST",
    data,
  });
}

// 获取设备类型、硬件类型枚举接口
export async function firmwareQueryType(params) {
  return request(`/mtsV2/firmware/queryType`, {
    params,
  });
}

// 批量固件升级-自定义升级-上传
export async function queryFrimwareUploadApi(file, params) {
  const formData = new FormData();
  formData.append("file", file);
  return request("/mtsV2/batchTask/oss/importStubFirmversion.do", {
    method: "POST",
    data: formData,
    params,
  });
}
/**
 * 场站列表相关接口
 */
// 场站列表
export async function getStubGroupList(data) {
  return request(`/mtsV2/omc/stubGroup/list`, {
    method: "POST",
    data,
  });
}

// 设备转移
export async function equipmentTransfer(params) {
  return request(`/mtsV2/omc/equipment/equipmentTransfer`, {
    method: "POST",
    data: params,
  });
}

// 批量设置屏保_单个设置屏保
export async function screensaverCfgApi(params) {
  return request(`/mtsV2/batchTask/cfg/screensaver`, {
    method: "POST",
    data: params,
  });
}
